import React from 'react'
import '../../styles/Diagnostic/DiagnosticBoutin.css'
import diagnosticBoutinSection1 from '../../assets/diagnostic/diagnostic-boutin-section1.jpg'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticBoutinSection2 from '../../assets/diagnostic/diagnostic-boutin-section2.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticBoutin() {

    const section3Accordion1Data = [
        {
            title: "Sécurité juridique et transparence :",
            text: "La Loi Boutin garantit la transparence entre le bailleur et le locataire en indiquant précisément la surface habitable du logement. Cette mesure évite les litiges potentiels relatifs à la surface réelle du bien loué, offrant ainsi une sécurité juridique aux deux parties."
        }, {
            title: "Obligation réalisation légale :",
            text: "La Loi Boutin est une obligation légale pour tout bail de location. L’absence dans le contrat de location peut entraîner des conséquences pour le bailleur, comme la possibilité pour le locataire de demander une diminution du loyer."
        }
    ]

    const section3Accordion2Data = [
        {
            title: "Expertise et précision :",
            text: "Un professionnel dispose des compétences et de l’équipement nécessaire pour mesurer avec précision la surface habitable de votre bien, en conformité avec les dispositions de la Loi Boutin. Cette expertise assure l’exactitude des informations fournies au locataire."
        }, {
            title: "Gain de temps :",
            text: "Faire appel à un professionnel pour réaliser la Loi Boutin vous fait gagner du temps et vous évitez les erreurs potentielles dans le calcul de la surface habitable, qui pourraient mener à des désaccords ou litiges futurs."
        }, {
            title: "Conformité légale :",
            text: "Réalisé par un professionnel garantit la conformité de votre dossier de localisation aux exigences légales, vous mettant à l’abri de sanctions potentielles."
        }
    ]

    const section5Accordion1Data = [
        {
            title: "Application :",
            text: "La Loi Boutin concerne la surface habitable du bien. La Loi Carrez, en revanche, est requise pour les transactions de vente et concerne la surface privative de lots de copropriété."
        }, {
            title: "Surface calculée :",
            text: "La Loi Boutin calcule la surface habitable, c’est-à-dire l’espace réellement utilisable par les occupants. La Loi Carrez mesure la surface privative, incluant les planchers des locaux clos et couverts, après déduction de certaines surfaces (moins de 1,80 m de hauteur, etc.), mais ne déduit pas les surfaces occupées par les murs, les escaliers, etc."
        }, {
            title: "Obligation :",
            text: "Pour la Loi Carrez, si la surface réelle est Inférieure de plus de 5 % à celle déclarée, l’acheteur peut demander une réduction du prix de vente. La Loi Boutin impose également l’exactitude de la surface habitable communiquée au locataire, avec des conséquences en cas d’erreur significative."
        },
    ]

    const section5Accordion2Data = [
        {
            title: "Loi Boutin :",
            text: "Si la surface habitable réelle est Inférieure de plus de 5 % à celle indiquée dans le bail de location, le locataire peut exiger une diminution du loyer. La demande doit être faite dans les premiers mois suivant la signature du bail, et la réduction de loyer sera effective rétroactivement depuis le début du bail."
        }, {
            title: "Loi Carrez :",
            text: "Dans le cadre d’une vente, si la surface réelle est inférieure de plus de 5 % à celle déclarée, l’acheteur peut demander une réduction du prix de vente proportionnellement à la différence de surface, dans un délai d’un an après la signature de l’acte de vente."
        },
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Loi Boutin - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Loi Boutin sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Loi Boutin - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Loi Boutin sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/loi-Boutin" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/loi-Boutin" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticBoutin'>
                    <div id='header'>
                        <div id='diagnosticBoutinHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Loi Boutin</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticBoutinSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticBoutinSection1Left'>
                                    <h1 className='sectionTitle'>À quoi sert-elle ?</h1>
                                    <div className='sectionText'>
                                        Loi Boutin, du nom de la ministre du Logement qui l’a introduite en 2009, est un document obligatoire à fournir par le bailleur lors de la signature ou du renouvellement d’un bail de location . Elle a pour objectif
                                        de déterminer la surface habitable exacte du logement mis en location. Voici une présentation de l’importance de la Loi Boutin pour la surface d’une localisation et les avantages d’utiliser à un professionnel pour sa réalisation.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticBoutinSection1Right'>
                                    <img src={diagnosticBoutinSection1} id='diagnosticBoutinSection1Image' alt='diagnostic-boutin-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticBoutinSection2'>
                        <Col sm={6}>
                            <div id='diagnosticBoutinSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <h1 className='sectionTitle'>Quels éléments sont pris en compte dans le calcul de la surface habitable ?</h1>
                                    <div className='sectionText'>
                                        Le calcul de la surface habitable selon la Loi Boutin exclut certaines parties du logement, telles que :
                                    </div>
                                    <ul>
                                        <li>Les surfaces dont la hauteur sous plafond est inférieure à 1,80 mètre.</li>
                                        <li>Les combles non aménagés, caves, sous-sols, garages, et terrasses.</li>
                                        <li>Les balcons, loggias et vérandas.</li>
                                        <li>Les parties communes et autres dépendances du logement.</li>
                                    </ul>
                                    <div className='sectionText'>
                                        Seuls les volumes habitables, c’est-à-dire les espaces de vie clos et couverts, après déduction des surfaces occupées par les murs, marches et cages d’escaliers, gaines, embrasures de portes et de fenêtres, sont inclus dans le calcul .
                                    </div>
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticBoutinSection2Right'>
                                    <img src={diagnosticBoutinSection2} id='diagnosticBoutinSection2Image' alt='diagnostic-boutin-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticBoutinSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticBoutinSection3Left'>
                                    <h1 className='sectionTitle'>L'importance de la loi Boutin</h1>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticBoutinSection3Right'>
                                    <h1 className='sectionTitle'>Avantages de recourir à un professionnel</h1>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticBoutinSection4'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Spécificités du mesurage loi Boutin</h1>
                            <div className='sectionText'>
                                Le mesurage  concerne la surface habitable d’un logement. Il s’applique exclusivement aux baux de location. La surface habitable est la somme des surfaces de plancher construits, après déduction des surfaces occupées par les murs, escaliers, cloisons,
                                marches, gaines, embrasures de portes et fenêtres. Ce calcul exclut également les combles non aménageables, caves, sous-sols, garages, terrasses, balcons, loggias, vérandas ainsi que les parties communes.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticBoutinSection5'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticBoutinSection5Left'>
                                    <h1 className='sectionTitle'>Différences entre la loi Boutin et la loi Carrez</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section5Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticBoutinSection5Right'>
                                    <h1 className='sectionTitle'>Possible réduction du prix du loyer en cas d'erreur sur ces métrages</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section5Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                    <div className='sectionText'>
                                        Ces dispositions légales soulignent l’importance de faire appel à des professionnels qualifiés pour réaliser  avec précision, afin d’éviter des ajustements financiers postérieurs et de garantir
                                        la transparence et l’équité des transactions immobilières.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticBoutin'>
                    <div id='header'>
                        <div id='diagnosticBoutinHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Loi Boutin</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticBoutinSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>À quoi sert-elle ?</h1>
                            <div className='sectionTextMobile'>
                                Loi Boutin, du nom de la ministre du Logement qui l’a introduite en 2009, est un document obligatoire à fournir par le bailleur lors de la signature ou du renouvellement d’un bail de location . Elle a pour objectif
                                de déterminer la surface habitable exacte du logement mis en location. Voici une présentation de l’importance de la Loi Boutin pour la surface d’une localisation et les avantages d’utiliser à un professionnel pour sa réalisation.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticBoutinSection1} id='diagnosticBoutinSection1ImageMobile' alt='diagnostic-boutin-section1' />
                        </Fade>
                    </div>
                    <div id='diagnosticBoutinSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Quels éléments sont pris en compte dans le calcul de la surface habitable ?</h1>
                            <div className='sectionTextMobile'>
                                Le calcul de la surface habitable selon la Loi Boutin exclut certaines parties du logement, telles que :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Les surfaces dont la hauteur sous plafond est inférieure à 1,80 mètre.</li>
                                    <li>Les combles non aménagés, caves, sous-sols, garages, et terrasses.</li>
                                    <li>Les balcons, loggias et vérandas.</li>
                                    <li>Les parties communes et autres dépendances du logement.</li>
                                </ul>
                            </div>
                            <div className='sectionTextMobile'>
                                Seuls les volumes habitables, c’est-à-dire les espaces de vie clos et couverts, après déduction des surfaces occupées par les murs, marches et cages d’escaliers, gaines, embrasures de portes et de fenêtres, sont inclus dans le calcul .
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <img src={diagnosticBoutinSection2} id='diagnosticBoutinSection2ImageMobile' alt='diagnostic-boutin-section2' />
                        </Fade>
                    </div>
                    <div id='diagnosticBoutinSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>L'importance de la loi Boutin</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Avantages de recourir à un professionnel</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticBoutinSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Spécificités du mesurage loi Boutin</h1>
                            <div className='sectionTextMobile'>
                                Le mesurage  concerne la surface habitable d’un logement. Il s’applique exclusivement aux baux de location. La surface habitable est la somme des surfaces de plancher construits, après déduction des surfaces occupées par les murs, escaliers, cloisons,
                                marches, gaines, embrasures de portes et fenêtres. Ce calcul exclut également les combles non aménageables, caves, sous-sols, garages, terrasses, balcons, loggias, vérandas ainsi que les parties communes.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticBoutinSection5Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Différences entre la loi Boutin et la loi Carrez</h1>
                            <div className='sectionAccordion sectionAccordionMobile'>
                                <Accordion>
                                    {section5Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Possible réduction du prix du loyer en cas d'erreur sur ces métrages</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section5Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                            <div className='sectionTextMobile'>
                                Ces dispositions légales soulignent l’importance de faire appel à des professionnels qualifiés pour réaliser  avec précision, afin d’éviter des ajustements financiers postérieurs et de garantir
                                la transparence et l’équité des transactions immobilières.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default DiagnosticBoutin